import SettingsRemote from "@mui/icons-material/SettingsRemote"

const ReaderIcon = props => <SettingsRemote {...props} />

export default ReaderIcon
